import { Component, Input } from '@angular/core';
import { LeftMenuItem } from '../NavItem';
import { CommonService } from '~util/common.service';

@Component({
  selector: 'ul[app-left-nav]',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.css']
})
export class LeftNavComponent {

  @Input() navItems: LeftMenuItem[];
  @Input() listType: string;
  @Input() openSubItems: string;

  constructor(private service: CommonService) {}


  toggleItemList(event: any) {
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.attributes.id;
    let element;
    if (idAttr) {
      const value = idAttr.nodeValue;
      element = document.getElementById(value);
    } else {
      element = target.parentNode;
    }
    const classList = element.classList;
    if (classList.contains('active')) {
      classList.remove('active');
      this.classListUtil(element.querySelector('.fa-angle-up')).remove('.fa-angle-up').add('fa-angle-down');
      element.nextElementSibling.classList.remove('subitems-open');
    } else {
      classList.add('active');
      this.classListUtil(element.querySelector('.fa-angle-down')).remove('fa-angle-down').add('fa-angle-up');
      element.nextElementSibling.classList.add('subitems-open');
    }
  }


  classListUtil(elt) {
    const list = elt.classList;

    return {
      toggle: function (c) { list.toggle(c); return this; },
      add: function (c) { list.add(c); return this; },
      remove: function (c) { list.remove(c); return this; }
    };

  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/navbar/left-nav/left-nav.component.ts